export default __webpack_public_path__ + "static/media/output-onlinegiftools2.06647834.gif";